import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes=[
  {
    path: '/',
    name:'Layout',
    component:() => import('../layout.vue'),
    redirect:{name:'blank'},
    children:[
      {
        path:"/blank",
        name:"blank",
        component: () => import('../views/blank/blank.vue')
      },
      {
        path:"/index0",
        name:"index0",
        component: () => import('../views/index0/index0.vue')
      },
      {
        path:"/index1",
        name:"index1",
        component: () => import('../views/index1/index1.vue')
      },
      {
        path:"/index2",
        name:"index2",
        component: () => import('../views/index2/index2.vue')
      },
      {
        path:"/index10",
        name:"index10",
        component: () => import('../views/index10/index10.vue')
      },
      {
        path:"/index12",
        name:"index12",
        component: () => import('../views/index12/index12.vue')
      },
      {
        path:"/ysxy",
        name:"ysxy",
        component: () => import('../views/ysxy/ysxy.vue')
      },
      {
        path:"/yhxy",
        name:"yhxy",
        component: () => import('../views/yhxy/yhxy.vue')
      },
      {
        path:"/index3",
        name:"index3",
        component: () => import('../views/index3/index3.vue')
      },
      {
        path:"/serve",
        name:"serve",
        component: () => import('../views/serve/serve.vue')
      },
      {
        path:"/serve1",
        name:"serve1",
        component: () => import('../views/serve1/serve1.vue')
      },
      {
        path:"/article",
        name:"article",
        component: () => import('../views/article/article.vue')
      },
      {
        path:"/village",
        name:"village",
        component: () => import('../views/village/village.vue')
      },
   
      
    ]
  },
]

const router = new VueRouter({
  routes
})
// 路由拦截
router.beforeEach((to,from,next) =>{
    next()
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js